import { type PayloadAction, createSlice } from '@reduxjs/toolkit';
import {
  type ExtrajudicialNotificationStatus,
  type NotificationStatus,
  type StringDate,
  extrajudicialNotificationStatus,
} from '../../types';
import type { Maybe } from '../../utils/types/maybe';

export type EjnFilter = {
  notificationStatuses: NotificationStatus[];
  pageNumber: number;
  pageSize: number;
  statuses: ExtrajudicialNotificationStatus[];
  repossessionStartedDate: Maybe<StringDate>;
  sentAt: Maybe<StringDate>;
};

export const initialEjnFilterState: EjnFilter = {
  notificationStatuses: ['PENDING_DECISION'],
  pageNumber: 1,
  pageSize: 20,
  statuses: extrajudicialNotificationStatus,
  repossessionStartedDate: undefined,
  sentAt: undefined,
};

const extrajudicialNotificationsFiltersSlice = createSlice({
  name: 'extrajudicialNotificationsFilters',
  initialState: initialEjnFilterState,
  reducers: {
    resetFilters: () => initialEjnFilterState,
    upsertFilters: (state, filter: PayloadAction<Partial<EjnFilter>>) => ({
      ...state,
      ...filter.payload,
    }),
    setFilters: (_state, filter: PayloadAction<Partial<EjnFilter>>) => ({
      ...initialEjnFilterState,
      ...filter.payload,
    }),
    incrementPageNumber: (state) => {
      state.pageNumber += 1;
    },
    decrementPageNumber: (state) => {
      if (state.pageNumber > 1) {
        state.pageNumber--;
      }
    },
  },
});

export const {
  upsertFilters,
  resetFilters,
  setFilters,
  incrementPageNumber,
  decrementPageNumber,
} = extrajudicialNotificationsFiltersSlice.actions;

export default extrajudicialNotificationsFiltersSlice.reducer;
